// extracted by mini-css-extract-plugin
module.exports = {"product-welcome":"product-welcome___RmAy6","welcome-text":"welcome-text___dADA2","product-info":"product-info___2K7Sk"};